import { apiErrorActionCreator } from '../common/apiErrorAction';

export const FETCH_CONTENT_REQUEST = 'FETCH_CONTENT_REQUEST';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILURE = 'FETCH_CONTENT_FAILURE';

export const fetchContentRequest = (contentId, topicId) => ({
  type: FETCH_CONTENT_REQUEST,
  payload: {
    contentId,
    topicId
  }
});

export const fetchContentSuccess = (response) => ({
  type: FETCH_CONTENT_SUCCESS,
  payload: {
    response
  }
});

export const fetchContentFailure = (response) =>
  apiErrorActionCreator(FETCH_CONTENT_FAILURE)(response);
